import getCookie, { COOKIE_MH_TOKEN } from '../../../../common/cookies';
import environment from '../../../../common/environment';
import { getResponseData } from '../../../../common/utils/api-utils';
import { MyDigitalProductAggregatedItem } from '../interface/my-digital-products-aggregated.interface';

/**
 * Fetches the My Digital Products list (with Inclusive Access blocks) from the
 * heclr endpoint (WECOOL-52277): GET {selfUrl}/user/digital-products.
 * Opt-in/out preference changes are saved separately via POST {optInOutUrl};
 * after a save the caller re-fetches this list for the latest state.
 *
 * MH_TOKEN is read INSIDE the call (never at module scope) — module-scope
 * reads happen before login and capture an empty string (known bug pattern).
 */
export async function getMyDigitalProductsAggregatedApiCall(): Promise<MyDigitalProductAggregatedItem[]> {
  const token = getCookie(COOKIE_MH_TOKEN);
  const url = new URL(`${environment().selfUrl}/user/digital-products`);
  // The heclr endpoint wraps the list in { products: [...], errors: [] }.
  const response = await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    })
  );
  return response?.products ?? [];
}
